<template>
  <div class="select" :class="selectModifiers">
    <div class="select__disabled" v-if="disabled"></div>
    <div class="select__placeholder">{{ placeholder }}<span v-if="required">*</span></div>
    <multiselect
      :adjust="adjust"
      :model-value="modelValue"
      :show-no-results="showNoResults"
      :options="options"
      :track-by="trackBy"
      :label="label"
      placeholder=""
      :show-labels="false"
      :searchable="searchable"
      :allow-empty="false"
      :max-height="maxHeight"
      :custom-label="customLabel"
      :tabindex="tabindex"
      :autofill-assist="autofillAssist"
      @close="(e) => $emit('close', e)"
      @select="(e) => $emit('select', e)"
      @update:model-value="updateValue"
    >
      <template v-slot:noResult>
        <div>No elements found.</div>
      </template>
    </multiselect>
  </div>
</template>

<script src="./select.js"></script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./select.scss" lang="scss"></style>
